const preType = 'BLOG_';

export const BlogsActionTypes = {
  SET_CURRENT_PAGE: `${preType}SET_CURRENT_PAGE`,
  GET_EXTENDED_BLOGS: `${preType}GET_EXTENDED_BLOGS`,
  SET_EXTENDED_BLOGS: `${preType}SET_EXTENDED_BLOGS`,
  SET_INITIAL_STATE: `${preType}SET_INITIAL_STATE`,
  GET_SEARCH_BLOG_LIST: `${preType}GET_SEARCH_BLOG_LIST`,
  SET_SEARCH_BLOG_LIST: `${preType}SET_SEARCH_BLOG_LIST`,
  SET_SEARCH_LOADING: `${preType}SET_SEARCH_LOADING`,
  SET_CSR_LOADING: `${preType}SET_CSR_LOADING`,
};

const setCurrentPage = (data: { currentPage: number, lastPage: number }) => ({
  type: BlogsActionTypes.SET_CURRENT_PAGE,
  data: data,
});
const getExtendedBlogs = (data: { typeId?: number }) => ({ type: BlogsActionTypes.GET_EXTENDED_BLOGS, data: data });
const setInitialState = (data: {}) => ({ type: BlogsActionTypes.SET_INITIAL_STATE, data: data });
const getSearchBlogList = (data: { searchValue: string }) => ({ type: BlogsActionTypes.GET_SEARCH_BLOG_LIST, data });
const setSearchLoading = (data: { searchLoading: boolean }) => ({ type: BlogsActionTypes.SET_SEARCH_LOADING, data });
const setCsrLoading = () => ({ type: BlogsActionTypes.SET_CSR_LOADING });

export const BlogsActions = {
  setCurrentPage: setCurrentPage,
  getExtendedBlogs: getExtendedBlogs,
  setInitialState: setInitialState,
  getSearchBlogList: getSearchBlogList,
  setSearchLoading: setSearchLoading,
  setCsrLoading: setCsrLoading,
};
